import { useEffect, useState } from 'react'
import { Ticket } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { raffleAPI } from '@/lib/api'

const fmt = (iso) => {
  if (!iso) return ''
  const d = new Date(iso)
  return d.toLocaleString('nl-BE', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })
}

/* Toont eigen raffle-tickets. Geen actie-knoppen: users kunnen niet zelf
   inruilen — enkel bij admin ter plaatse. */
export default function RaffleUserWidget() {
  const [data, setData] = useState(null)
  const [err, setErr] = useState(null)

  useEffect(() => {
    raffleAPI.getMine()
      .then(r => setData(r.data))
      .catch(e => {
        if (e.response?.status === 403) setErr('disabled')
        else setErr(e.response?.data?.error || e.message)
      })
  }, [])

  if (err === 'disabled') return null // module uit → widget verdwijnt
  if (err) return null // stille faalmodus — dit is bij-info, geen kern

  const open = data?.counts?.open ?? 0
  const used = data?.counts?.used ?? 0

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Ticket className="h-4 w-4" style={{ color: '#E4C265' }} />
          Raffle-tickets
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-baseline gap-4">
          <div>
            <div className="text-3xl font-bold" style={{ color: '#E4C265' }}>{open}</div>
            <div className="pf-mono text-[10px] uppercase tracking-widest text-muted-foreground">Open</div>
          </div>
          <div>
            <div className="text-xl font-semibold text-muted-foreground">{used}</div>
            <div className="pf-mono text-[10px] uppercase tracking-widest text-muted-foreground">Ingediend</div>
          </div>
        </div>
        <p className="text-xs text-muted-foreground">
          Verdien 1 ticket per schijf besteding in de kassa. Kom je tickets inruilen bij een admin voor een klein spel.
        </p>
        {data?.tickets?.length > 0 && (
          <div className="space-y-1 border-t border-border pt-2">
            {data.tickets.slice(0, 5).map(t => (
              <div key={t.id} className="flex items-center justify-between text-xs">
                <span className={t.used_at ? 'text-muted-foreground line-through' : 'text-foreground'}>
                  #{t.id}
                </span>
                <span className="text-muted-foreground">{fmt(t.granted_at)}</span>
                {t.used_at && <span className="pf-mono text-[10px] uppercase text-muted-foreground">ingediend</span>}
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
